/**
 * Studio Kiwik
 * Ajoute au bouton de submit du formulaire du panier la fonction : 
 * Si l'input checkbox des CGV est coché, valide et envoie le formulaire
 * Si elle n'est pas cochée, affiche un message
 */

$(document).ready(function() {

    var $label = $("#cgv-label");
    var times = 3; // Nombre de clignotements
    var speed = 300; // Vitesse de clignotement en millisecondes (300ms = 0.3 seconde)

    function blink() {
        $label.fadeOut(speed).fadeIn(speed, function() {
            times--;
            if (times > 0) {
                blink(); // Appel récursif jusqu'à ce que `times` atteigne 0
            }
        });
    }
  
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        // window.scrollTo(0, document.body.scrollHeight);
        // var $container = $("html,body");
        // var $scrollTo = $('.cgv');

        // $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0},300);
        $("html, body").animate({ scrollTop: $(document).height()-$(window).height() });
        //blink(); // Lancer le clignotement
        alert("Vous devez accepter les termes et les conditions générales de vente pour passer commande.");
        return false;
      }
    });
});